import Dashboard from "../components/ui/dashboard";


const DashboardPage = () => {
  return (
    <Dashboard/>
  );
};

export default DashboardPage
